// extracted by mini-css-extract-plugin
module.exports = {"section--label":"section--label__3lh05"};